import type { SummaryByService } from '@/features/summary/api';
import { formatBRL } from '@/lib/utils';

interface Props {
  items: SummaryByService[];
}

export function ByServiceBreakdown({ items }: Props) {
  if (items.length === 0) {
    return (
      <section className="rounded-xl border border-(--color-border) bg-(--color-surface) p-5">
        <h2 className="mb-3 font-display text-lg font-semibold">Por serviço</h2>
        <p className="text-sm text-(--color-fg-muted)">
          Nenhum plantão no mês.
        </p>
      </section>
    );
  }

  return (
    <section className="rounded-xl border border-(--color-border) bg-(--color-surface) p-5">
      <h2 className="mb-4 font-display text-lg font-semibold">Por serviço</h2>
      <ul className="flex flex-col gap-4">
        {items.map((s) => (
          <li key={s.serviceId}>
            <div className="flex items-center justify-between gap-3">
              <div className="flex items-center gap-2 min-w-0">
                <span
                  aria-hidden
                  className="h-3 w-3 flex-shrink-0 rounded-full"
                  style={{ backgroundColor: s.color }}
                />
                <span className="truncate text-sm font-medium">{s.name}</span>
              </div>
              <span className="text-sm tabular-nums text-(--color-fg)">
                {formatBRL(s.total)}
              </span>
            </div>
            <div className="mt-2 flex items-center gap-2">
              <div
                className="h-2 flex-1 overflow-hidden rounded-full bg-(--color-surface-elevated)"
                role="progressbar"
                aria-valuenow={s.percentage}
                aria-valuemin={0}
                aria-valuemax={100}
                aria-label={`${s.name}: ${s.percentage}%`}
              >
                <div
                  className="h-full rounded-full"
                  style={{
                    width: `${Math.max(2, Math.min(100, s.percentage))}%`,
                    backgroundColor: s.color,
                  }}
                />
              </div>
              <span className="w-16 text-right text-xs tabular-nums text-(--color-fg-muted)">
                {s.percentage.toFixed(1)}%
              </span>
            </div>
            <p className="mt-1 text-xs text-(--color-fg-muted)">
              {s.shiftsCount} plantões · {s.itemsCount} procedimentos
            </p>
          </li>
        ))}
      </ul>
    </section>
  );
}
